module.exports = __webpack_public_path__ + "static/image/history/pc/201006.ver2_0_2.jpg?9d9b98b3";